import * as React from 'react';
import styled from '@emotion/styled';
import { rgba } from 'polished';

import FacebookButton from '~/theseus/components/FacebookButton';
import Modal from '~/theseus/components/Modal';
import { useAuthSelector } from '../containers/Auth';

const Body = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  h1 {
    margin-bottom: 20px; 
    font-size: 21px;
  }

  p {
    margin: auto auto 40px;
    padding: 10px;
    max-width: 360px;
    text-align: left;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 500;
    background: ${rgba('#000', 0.05)};
    border-radius: 2px;
    box-shadow: inset 0 0 0 1px ${rgba('#000', 0.1)};
  }
`;

function FbLoginModal() {
  const isLoggedOut = useAuthSelector(state => state.matches('loggedOutFB'));

  return (
    <Modal
      isOpen={isLoggedOut}
      withClose={false}
      contentStyle={{ width: 540, height: 'auto', alignItems: 'unset' }}
    >
      <Body>
        <h1>Please log in to Facebook</h1>
        <p>
          Before you can create posts and ads on Facebook, we need your
          permission to view the pages you manage, publish to your page, and
          manage your ad account
          <br />
          <br />
          We will never post to Facebook without your permission.
        </p>
        <FacebookButton size="lg" />
      </Body>
    </Modal>
  );
}

export default FbLoginModal;
